import { render, staticRenderFns } from "./business-note-list-modal.vue?vue&type=template&id=56cb0260"
import script from "./business-note-list-modal.vue?vue&type=script&lang=js"
export * from "./business-note-list-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports